import { z } from "zod";

export const kuwaitForecastSchema = z.object({
	weather_state_AM_EN: z.string(),
	weather_state_AM_AR: z.string(),
	weather_state_PM_EN: z.string(),
	weather_state_PM_AR: z.string(),
	sea_state_AM_EN: z.string(),
	sea_state_AM_AR: z.string(),
	sea_state_PM_EN: z.string(),
	sea_state_PM_AR: z.string(),
});

export type kuwaitForecastType = z.infer<typeof kuwaitForecastSchema>;
